import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './plasma-vs-fiber-laser/HeroSection';
import { DefinitionsSection } from './plasma-vs-fiber-laser/DefinitionsSection';
import { ComparisonSection } from './plasma-vs-fiber-laser/ComparisonSection';
import { MainDifferencesSection } from './plasma-vs-fiber-laser/MainDifferencesSection';
import { VideosSection } from './plasma-vs-fiber-laser/VideosSection';
import { AdditionalLinksSection } from './plasma-vs-fiber-laser/AdditionalLinksSection';
export function PlasmaVsFiberLaserPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-3495">
      <SeoBar data-id="element-3496" />
      <Header data-id="element-3497" />
      <main className="flex-grow" data-id="element-3498">
        <div className="w-full bg-gray-50 pb-20" data-id="element-3499">
          <HeroSection data-id="element-3500" />
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12" data-id="element-3501">
            <DefinitionsSection data-id="element-3502" />
            <ComparisonSection data-id="element-3503" />
            <MainDifferencesSection data-id="element-3504" />
            <VideosSection data-id="element-3505" />
            <AdditionalLinksSection data-id="element-3506" />
          </div>
        </div>
      </main>
      <Footer data-id="element-3507" />
    </div>;
}